// componentes/A11ySkipLink.tsx
import React from "react";
import { Box } from "@mui/material";

export const A11ySkipLink: React.FC = () => (
  <Box
    component="a"
    href="#content"
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      backgroundColor: "#000",
      color: "#fff",
      padding: "8px",
      zIndex: 1000,
      textDecoration: "none",
      transform: "translateY(-100%)",
      "&:focus": {
        transform: "translateY(0)",
      },
    }}
    tabIndex={1}
    accessKey="s"
  >
    Pular para o conteúdo
  </Box>
);
